<style lang="scss" src="./TipoSolicitud.scss"></style>
<template src="./TipoSolicitud.html"></template>

<script>
import {Button, Option, Select} from 'element-ui'
import {TipoSolicitud} from "@/enums/tipoSolicitud";
import {requestAfiliacionMixin} from "@/api/ciudadano/afiliacionApi";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {RouterMixin} from "@/mixins/routerMixin";

export default {
  name: "TipoSolicitud",
  components: {
    [Button.name]: Button,
    [Option.name]: Option,
    [Select.name]: Select,
  },
  mixins: [
    requestAfiliacionMixin,
    NotifyMixin,
    ScreenSizeMixin,
    RouterMixin
  ],
  data: () => ({
    loading: true,
    errored: false,
    model: {
      seleccionado: '',
      tipos: [],
    },
  }),
  beforeMount() {
    this.listaTipoSolicitud();
  },
  methods: {
    listaTipoSolicitud() {
      this.getTiposSolicitud()
        .then(response => {
          this.$log.debug('getTiposSolicitud', response.data.statusCode)

          if (response.data.statusCode === 200) {
            const datos = JSON.parse(response.data.datos)
            this.$log.debug(datos)

            this.model.tipos = datos
          } else {
            this.showError('Ocurrió un error inesperado al cargar los tipos de Solicitud')
          }
        })
        .catch(err => {
          this.$log.fatal('getTiposSolicitud', err.response, err.request)
          this.showError('Ocurrió un error inesperado al cargar los tipos de Solicitud')
        })
        .finally(() => {
          this.loading = false
        })
    },
    tipoAccion() {
      this.$log.debug('tipoAccion', this.model.seleccionado)

      switch (this.model.seleccionado) {
        case TipoSolicitud.afiliacionpartido:
          this.navigate({name: 'afiliacion-solicitud'})
          break
        case TipoSolicitud.renunciapartido:
          this.navigate({name: 'renuncia-partido-politico'})
          break
        case TipoSolicitud.certificadoafiliacion:
          this.navigate({name: 'GeneracionCertificado'})
          break
        case TipoSolicitud.certificadohistorico:
          this.navigate({name: 'solicitudes-historicas'})
          break
        case TipoSolicitud.reclamo:
          this.navigate({name: 'reclamo'})
          break
        default:
          this.showWarn('No se ha implementado la función')
      }
    },
  },
  computed: {
    isTipoSelecionado: function () {
      return this.model.seleccionado !== '';
    },
  }
}
</script>
